import { Component } from '@theme/component';
import { DrawerOpenEvent } from '@theme/theme-drawer';

/**
 * Deckface Cart Drawer UI Controller
 *
 * Cart synchronization is handled globally by:
 * assets/deckface-cart-sync.js
 *
 * This component is responsible only for drawer UI.
 */
class CartDrawerComponent extends Component {
  #summaryThreshold =
    0.5;


  get #themeDrawer() {
    return /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */ (
      this.closest(
        'theme-drawer'
      )
    );
  }


  get #dialog() {
    return this.closest(
      'dialog'
    );
  }


  connectedCallback() {
    super.connectedCallback();


    this.#themeDrawer?.addEventListener(
      DrawerOpenEvent.eventName,
      this.#handleDrawerOpen
    );


    document.addEventListener(
      'deckface:cart-rendered',
      this.#handleCartRendered
    );


    if (
      this.#themeDrawer?.hasAttribute(
        'open'
      )
    ) {
      this.#handleDrawerOpen();
    }
  }


  disconnectedCallback() {
    super.disconnectedCallback();


    this.#themeDrawer?.removeEventListener(
      DrawerOpenEvent.eventName,
      this.#handleDrawerOpen
    );


    document.removeEventListener(
      'deckface:cart-rendered',
      this.#handleCartRendered
    );
  }


  #handleDrawerOpen = () => {
    this.#updateStickyState();
  };


  #handleCartRendered = () => {
    requestAnimationFrame(
      () => {
        this.#updateStickyState();
      }
    );
  };


  #updateStickyState() {
    const dialog =
      this.#dialog;


    if (!dialog) {
      return;
    }


    const content =
      dialog.querySelector(
        '.cart-drawer__content'
      );


    const summary =
      dialog.querySelector(
        '.cart-drawer__summary'
      );


    if (
      !content ||
      !summary
    ) {
      dialog.setAttribute(
        'cart-summary-sticky',
        'false'
      );

      return;
    }


    const drawerHeight =
      dialog
        .getBoundingClientRect()
        .height;


    const summaryHeight =
      summary
        .getBoundingClientRect()
        .height;


    const ratio =
      summaryHeight /
      Math.max(
        drawerHeight,
        1
      );


    dialog.setAttribute(
      'cart-summary-sticky',

      ratio >
      this.#summaryThreshold
        ? 'false'
        : 'true'
    );
  }
}


if (
  !customElements.get(
    'cart-drawer-component'
  )
) {
  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );
}